import { JSONSerializable } from '../../../util/json';
import { Dec, Int } from '../../numeric';
import { ValAddress } from '../../strings';
import { Validator } from '../Validator';

export class MsgEditValidator extends JSONSerializable<MsgEditValidator.Data> {
  constructor(
    public Description: Validator.Description,
    public address: ValAddress,
    public commission_rate?: Dec,
    public min_self_delegation?: Int
  ) {
    super();
  }

  public static fromData(data: MsgEditValidator.Data): MsgEditValidator {
    const {
      value: { Description, address, commission_rate, min_self_delegation },
    } = data;
    return new MsgEditValidator(
      Description,
      address,
      commission_rate ? new Dec(commission_rate) : undefined,
      min_self_delegation ? new Int(min_self_delegation) : undefined
    );
  }

  public toData(): MsgEditValidator.Data {
    const { Description, address, commission_rate, min_self_delegation } = this;
    return {
      type: 'staking/MsgEditValidator',
      value: {
        Description,
        address,
        commission_rate: commission_rate ? commission_rate.toString() : null,
        min_self_delegation: min_self_delegation
          ? min_self_delegation.toString()
          : null,
      },
    };
  }
}

export namespace MsgEditValidator {
  export interface Data {
    type: 'staking/MsgEditValidator';
    value: {
      Description: any;
      address: ValAddress;
      commission_rate: string | null;
      min_self_delegation: string | null;
    };
  }
}
